import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const supplierVouchersRoutesDictionary = moduleRouteDictionaryFactory(
  'supplierVouchers',
  'supplierVouchers',
  {
    list: 'list',
  },
);
